export const EXTENSION_ICONS = {
  LEARN_AND_EARN: {
    IDLE: 'assets/icons/timeback_adapter_128.png',
    LEARNING: 'assets/icons/timeback_adapter_128.png',
    DEFAULT: 'assets/icons/timeback_adapter_128.png',
  },
  LEARN_WITH_AI: {
    IDLE: 'assets/icons/timeback_adapter_128.png',
    LEARNING: 'assets/icons/timeback_adapter_128.png',
    DEFAULT: 'assets/icons/timeback_adapter_128.png',
  },
};
